import Layout from "@components/Layout";
import BrandStoryContainer from "@containers/BrandStoryContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import WrapperProvider from "@providers/WrapperProvider";
import { getServer } from "@translations/next";
import _ from "lodash";
import StrapiService from "@services/StrapiService";
import FooterService from "@services/FooterService";

export default function About(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <BrandStoryContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}
// export { getServerSideProps };
export const getServerSideProps = getServer(async (params: any) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "hotel10-brand-story");
  const res = await StrapiService.find({ populate: "deep", locale });
  const footerData = await FooterService.fetchByHotel("amanaki-thao-dien", locale);
  return {
    hotel: "amanaki-thao-dien",
    pageData: _.get(res, "data", {}),
    footerData,
  };
});
